import { useState, useEffect, useCallback } from 'react';
import {
  readAccountMenuDarkMode,
  writeAccountMenuDarkMode,
  ACCOUNT_MENU_DARK_EVENT,
} from '../utils/accountMenuDarkMode';

export function useAccountMenuDarkMode() {
  const [accountMenuDark, setAccountMenuDark] = useState(readAccountMenuDarkMode);

  useEffect(() => {
    const onChange = (event) => {
      setAccountMenuDark(Boolean(event.detail?.enabled));
    };
    window.addEventListener(ACCOUNT_MENU_DARK_EVENT, onChange);
    return () => window.removeEventListener(ACCOUNT_MENU_DARK_EVENT, onChange);
  }, []);

  const toggleAccountMenuDark = useCallback(() => {
    setAccountMenuDark((prev) => {
      const next = !prev;
      writeAccountMenuDarkMode(next);
      return next;
    });
  }, []);

  return { accountMenuDark, toggleAccountMenuDark };
}
